// Frontend helper to render a stored social handle safely.
// The DB column may contain a clean username for new accounts, but legacy
// rows can hold a full profile URL with tracking params (e.g. ?igsh=...).
// This helper extracts the canonical username from either form.

const EXTRACTORS = {
  instagram: {
    domain: /instagram\.com\/([^\s?\/#]+)/i,
    valid: /^[a-zA-Z0-9._]{1,30}$/,
    buildUrl: (u) => `https://www.instagram.com/${u}/`
  },
  tiktok: {
    domain: /tiktok\.com\/@?([^\s?\/#]+)/i,
    valid: /^[a-zA-Z0-9._]{2,24}$/,
    buildUrl: (u) => `https://www.tiktok.com/@${u}`
  },
  facebook: {
    domain: /facebook\.com\/([^\s?\/#]+)/i,
    valid: /^(?!share$|profile\.php$|groups$|events$|watch$).+$/i,
    buildUrl: (u) => `https://www.facebook.com/${u}`
  }
};

export function extractSocialUsername(platform, rawValue) {
  if (!rawValue || typeof rawValue !== 'string') return '';
  const cfg = EXTRACTORS[platform];
  if (!cfg) return '';

  let candidate = rawValue.trim();
  if (!candidate) return '';

  if (/^https?:\/\//i.test(candidate)) {
    const m = candidate.match(cfg.domain);
    candidate = m ? m[1] : '';
  } else {
    candidate = candidate.replace(/^@/, '');
  }

  candidate = candidate.trim();
  if (!candidate) return '';

  return cfg.valid.test(candidate) ? candidate : '';
}

export function buildSocialProfileUrl(platform, rawValue) {
  const username = extractSocialUsername(platform, rawValue);
  if (!username) return '';
  return EXTRACTORS[platform].buildUrl(username);
}
